import { db } from "../firebase";
import _ from "lodash";

const state = {
  ranges: {}
  // ranges: {
  //   manual_welding: {
  //     id: "manual_welding",
  //     name: "Manual Welding",
  //     categories: {
  //       mma_welding: {
  //         id: "mma_welding",
  //         name: "MMA Welding",
  //         productSelectionToolUri:
  //           "http://www.africau.edu/images/default/sample.pdf",
  //         categories: {
  //           inverter_units: {
  //             id: "inverter_units",
  //             name: "Inverter Units",
  //             description:
  //               "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //             imageUri:
  //               "https://images.unsplash.com/photo-1514300403573-6d9a8fe888f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=2867&q=80",
  //             productSelectionToolUri:
  //               "http://www.africau.edu/images/default/sample.pdf",
  //             products: {
  //               citoarc_1900c_force: {
  //                 id: "citoarc_1900c_force",
  //                 name: "CITOARC 1900C FORCE",
  //                 brand: "CITOARC",
  //                 imageUri:
  //                   "https://images.unsplash.com/photo-1514300403573-6d9a8fe888f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=2867&q=80",
  //                 productSelectionToolUri:
  //                   "http://www.africau.edu/images/default/sample.pdf",
  //                 pdfUri: "http://www.africau.edu/images/default/sample.pdf"
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
};

const getters = {
  ranges: state => state.ranges
};

const actions = {
  async fetchRanges(context) {
    const snap = await db.collection("ranges").get();
    const ranges = _.reduce(
      snap.docs,
      (acc, doc) => ({
        ...acc,
        [doc.id]: doc.data()
      }),
      {}
    );
    context.commit("setRanges", ranges);
  }
};

const mutations = {
  setRanges(state, ranges) {
    state.ranges = ranges;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
